import { ComponentIds, } from "@inter-ikea-core/core";
import { SystemBase } from "@inter-ikea-core/core-toolbox";
import EntityIsReplacingComponent from "../components/EntityIsReplacingComponent";
import { LEFT, RIGHT } from "../constants";
import { addAttachedToRelationsBasedOnAlignments, getEntitiesBySideBasedOnAlignments, removeEntityAttachmentBySide, } from "../functions/attachedTo";
import logEmptyFunctionWarning from "../functions/logEmptyFunctionWarning";
import { COMPONENT_IDS } from "../storage2ComponentIDs";
export class AttachmentsSystem extends SystemBase {
    constructor(entityManager) {
        super(ComponentIds.ALIGNMENT_CONNECTIONS_COMPONENT_ID);
        this.entityManager = entityManager;
        this.doingChangesOnComponent = [];
        this.id = "AttachmentsSystem";
        this.mandatoryComponents = [COMPONENT_IDS.MERGEABLE_COMPONENT];
        this.systemsAfterMe = null;
        this.systemsBeforeMe = null;
    }
    onAddComponent(_entity, _newComponent) {
        addAttachedToRelationsBasedOnAlignments(_newComponent);
        if (_entity.hasComponent(EntityIsReplacingComponent.id))
            _entity.removeComponent(EntityIsReplacingComponent.id);
    }
    onUpdateComponent(_entity, _oldComponent, _newComponent) {
        logEmptyFunctionWarning("onUpdateComponent", this.id);
    }
    onRemoveComponent(_entity, _oldComponent) {
        const removeAttachedToByAlignmentConnection = (component) => {
            const { left, right } = getEntitiesBySideBasedOnAlignments(component);
            removeEntityAttachmentBySide(left, RIGHT);
            removeEntityAttachmentBySide(right, LEFT);
        };
        _oldComponent.connections.forEach(removeAttachedToByAlignmentConnection);
    }
}
